import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { onlyNumber } from "../../constant/utils";
import { validateGeneralEnquiry } from "../../constant/validation";
import { dashboardAction, submitAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SeoAdd from "../Seo/SeoAdd";
import { useTranslation } from "react-i18next";
import Recaptcha from "../ReCaptcha";

const initialValue = {
  Name: "",
  Email: "",
  Mobile: "",
  Message: "",
  CityId: "",
  Type: "1",
  UtmSource: "",
  UtmMedium: "",
  UtmCampaign: "",
  Checkbox: false,
  GRecaptcha: "",
};

const PrivilegeMembershipCard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const cityData = useSelector((state: any) => state.dashboard.cityAll);
  const loading = useSelector((state: any) => state.common.loader);

  useEffect(() => {
    window?.scrollTo(0, 0);
    return () => {};
  }, []);

  const handleSubmit = (values: any) => {
    let val: any = { ...values };
    val.SourceUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    val.UtmSource = urlParams.get("utm_source");
    val.UtmMedium = urlParams.get("utm_medium");
    val.UtmCampaign = urlParams.get("utm_campaign");
    dispatch(submitAction.prevMembershipFormAction(val, history));
  };

  return (
    <>
      <SeoAdd slug={ROUTE.PRIVILEGEMEMBERSHIP} />
      <BreadCrumb
        page={t("privilege_membership_card_bread")}
        data={{ slug: "", path: "" }}
      />
      <section className="clinical-trial-section padtp-20">
        <div className="container" id="section2">
          <div className="row">
            <div className="col-md-12">
              <div className="overview-wrap text-center">
                <img
                  src="assets/img/membership-card-banner.png"
                  className="scale round_img"
                  alt=""
                />
                <div className="headingmains text-center pb-3">
                  <h1 className="right aos-init mt-3 mt-lg-5">
                    Privilege Membership Card - “Family Inner Fitness”
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="news_section pb-4">
        <div className="container">
          <div className="row pt-lg-3 for-flex-direction">
            <div className="col-md-6">
              <div className="clinical-content part-headfont w-100">
                <h5>Offers</h5>
                <div className="privilege-Card-content w-100 float-left">
                  <p>
                    <strong>Routine Tests</strong>
                  </p>
                  <div className="sub-card-list">
                    <ul>
                      <li>
                        <strong>20% Discount for Senior Citizens</strong> (Age
                        of person 60 years+)
                      </li>
                      <li>
                        <strong>15% Discount</strong> for other age groups.
                      </li>
                    </ul>
                  </div>
                  <p>
                    <strong>Preventive Health check Packages</strong>{" "}
                    <span>(including Inner Fitness Packages)</span>
                  </p>
                  <div className="sub-card-list">
                    <ul>
                      <li>
                        <strong>10% Discount</strong> for all age groups
                      </li>
                    </ul>
                  </div>
                  <p>
                    <strong>Routine Tests</strong> <span>(outsourced)</span>
                  </p>
                  <div className="sub-card-list">
                    <ul>
                      <li>
                        <strong>10% Discount</strong> for all age groups
                      </li>
                    </ul>
                  </div>
                  <p>
                    <strong>Specialised Tests</strong>{" "}
                    <span>(both In-house & Outsourced)</span>
                  </p>
                  <div className="sub-card-list">
                    <ul>
                      <li>
                        <strong>10% Discount</strong> for all age groups
                      </li>
                    </ul>
                  </div>
                  <p>
                    <strong>Free Home Collection</strong>{" "}
                    <span>on bill value of Rs 1000 and above.</span>
                  </p>
                  <p>
                    <strong>Free Doctor consult on test report</strong>{" "}
                    <span>with prior appointment.</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <Formik
                initialValues={initialValue}
                enableReinitialize={true}
                validationSchema={validateGeneralEnquiry}
                onSubmit={(val: any) => {
                  handleSubmit(val);
                }}
                render={({
                  values,
                  handleChange,
                  errors,
                  touched,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                }: any) => (
                  <form onSubmit={handleSubmit}>
                    <div className="h-services m-top-13">
                      <div className="infobox_wrapper">
                        <h3 className="mr-10">
                          {t("privilege_membership_form")}
                        </h3>
                        <div className="ln-1 mr-10">
                          {t("neurology_form_note")}
                        </div>
                        <div className="form-group">
                          <input
                            type="text"
                            name="Name"
                            className="form-control"
                            placeholder={t("name")}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.Name}
                          />
                          {touched?.Name && errors?.Name && (
                            <span className="error_message">
                              {t(errors?.Name)}
                            </span>
                          )}
                        </div>
                        <div className="form-group">
                          <input
                            type="text"
                            name="Mobile"
                            className="form-control"
                            placeholder={t("mobile_number")}
                            onKeyPress={onlyNumber}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.Mobile}
                          />
                          {touched?.Mobile && errors?.Mobile && (
                            <span className="error_message">
                              {t(errors?.Mobile)}
                            </span>
                          )}
                        </div>
                        <div className="form-group">
                          <select
                            className="form-control"
                            name="CityId"
                            id="CityId"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.CityId}
                          >
                            <option value="">{t("city")}*</option>
                            {cityData &&
                              cityData.length > 0 &&
                              cityData?.map((item: any, i: any) => (
                                <option
                                  value={item?.Id}
                                  key={i}
                                  className="text-uppercase"
                                >
                                  {t(item?.Name)}
                                </option>
                              ))}
                          </select>
                          {touched?.CityId && errors?.CityId && (
                            <span className="error_message">
                              {t(errors?.CityId)}
                            </span>
                          )}
                        </div>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder={t("email")}
                            name="Email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.Email}
                          />
                          {touched?.Email && errors?.Email && (
                            <span className="error_message">
                              {errors?.Email}
                            </span>
                          )}
                        </div>
                        <div className="form-group">
                          <textarea
                            className="form-control"
                            placeholder={t("message")}
                            name="Message"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.Message}
                          ></textarea>
                          {touched?.Message && errors?.Message && (
                            <span className="error_message">
                              {t(errors?.Message)}
                            </span>
                          )}
                        </div>
                        <div className="d-flex for-check-style">
                          <input
                            type="checkbox"
                            name="Checkbox"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            id="checkbox_id"
                          />
                          <label className="mx-2 mb-0" htmlFor="checkbox_id">
                            By clicking you accept to the{" "}
                            <a
                              className="text-info"
                              href="https://oncquestlabs.com/terms-condition"
                            >
                              terms and conditions
                            </a>{" "}
                            and the{" "}
                            <a
                              className="text-info"
                              href="https://oncquestlabs.com/privacy-policy"
                            >
                              Privacy Policy.
                            </a>
                          </label>
                        </div>
                        <div>
                          {touched?.Checkbox && errors?.Checkbox && (
                            <span className="error_message">
                              {errors?.Checkbox}
                            </span>
                          )}
                        </div>
                        <div className="form-group">
                          <Recaptcha
                            touch={touched?.GRecaptcha}
                            error={errors?.GRecaptcha}
                            onChange={(token: any) =>
                              setFieldValue("GRecaptcha", token)
                            }
                            onExpired={() => setFieldValue("GRecaptcha", "")}
                          />
                        </div>
                        <button
                          type="submit"
                          className="book--hexagon active"
                          disabled={loading}
                        >
                          <span>
                            {loading ? (
                              <>
                                Submitting...
                                <i className="fa fa-spinner fa-spin ml-20"></i>
                              </>
                            ) : (
                              <>
                                {t("submit_btn")}
                                <i
                                  className="fa fa-long-arrow-right ml-20"
                                  aria-hidden="true"
                                ></i>
                              </>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="pt-3 privilege-Card-content w-100 float-left">
                <h5>Exceptions</h5>
                <div className="sub-card-list">
                  <ul>
                    <li>
                      <strong>No discount</strong> will be given on{" "}
                      <strong>Government-Capped tests</strong> and{" "}
                      <strong>International send outs.</strong>
                    </li>
                    <li>
                      The offer <strong>cannot be clubbed</strong> with any
                      other discount or offer.
                    </li>
                    <li>
                      Oncquest Laboratories Ltd. has the{" "}
                      <strong>right to cancel, modify</strong> or extend the
                      offer without any prior notice.
                    </li>
                    <li>
                      <strong>Home Collection</strong> facility will be given on
                      the basis of{" "}
                      <strong>availability of Phlebotomy slots.</strong> It may
                      not be available at few locations.
                    </li>
                    <li>
                      <strong>Free Doctor consult</strong> will be given on
                      prior appointment and will be limited to report
                      consultation only. This facility may not be available at
                      few locations.
                    </li>
                    <li>
                      <strong>The Privilege Membership Card</strong> Facility
                      may not be available at a few locations.
                    </li>
                  </ul>
                </div>
                <h5>How to avail</h5>
                <div className="sub-card-list">
                  <ul>
                    <li>
                      <strong>Walk-ins:</strong> Customer will be required to
                      show the Membership Card at the front desk (of Lab or
                      Centre) before availing the test.
                    </li>
                    <li>
                      <strong>Home visit:</strong> Customer will call up the
                      call centre to give test details and book an appointment.
                      The customer will also pre-announce the loyalty card so
                      that necessary discounts can be calculated by customer
                      care and the final bill amount will be communicated to the
                      customer. During home sample collection, customer will
                      show the membership card to the visiting phlebotomist for
                      confirmation.
                    </li>
                  </ul>
                </div>
                <h5>Validity</h5>
                <div className="sub-card-list">
                  <ul>
                    <li>
                      The Card will be valid for 1 year from the date of issue.
                    </li>
                    <li>
                      After one year the patient can still get a discount by
                      showing his card. At the same time, a new card will be
                      issued by Oncquest Laboratories Ltd.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivilegeMembershipCard;
